import { useMemo } from 'react'

import { useEnableAnimation } from '../lib/enable-animation'

type UseBlockAppearanceProps = {
	blockId?: string
}

export const useBlockAppearance = ({ blockId }: UseBlockAppearanceProps) => {
	const { blocks } = useEnableAnimation()

	return useMemo(
		() => ({
			inProp: !blockId || !blocks ? true : blocks[blockId],
			mountOnEnter: !blockId || !blocks ? true : blocks[blockId],
		}),
		[blocks, blockId]
	)
}
